import { useState } from 'react';

import KnowledgeBAseFiles from '../../components/KnowledgeBase/KnowledgeBAseFiles';
import KnowledgeBaseFileUploadModal from '../../components/modals/KnowledgeBaseFileUploadModal';

import Questionnaire from '../../components/KnowledgeBase/Questionnaire';
import { useStores } from '../../components/UserJourny/FirstUserJourney/useStores';
import QuestionnaireDrawer from '../../components/GeneralSupportFlow/QuestionnaireDrawer';
import { useAlert } from '../../hooks/useAlert';
import { IStoreKnowledgeRequest } from '../../schemas/apis/interface';
import useCreateStoreKnowledge from '../../hooks/useCreateStoreKB';

const KnowledgeBase = ({
  selectedStore,
  selectedMethod,
}: {
  selectedStore: any;
  selectedMethod: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewQuestion, setIsNewQuestion] = useState(false);
  const [isQuestionnaireDrawerOpen, setIsQuestionnaireDrawerOpen] =
    useState(false);
  const { showAlert } = useAlert();
  const { createStoreKnowledge, isPending } = useCreateStoreKnowledge();

  const { storesListLoading } = useStores();

  const handleSaveQuestions = (questions: any[]) => {
    try {
      const formattedData: IStoreKnowledgeRequest = {
        stores: [
          {
            storeId: selectedStore?.id,
            storeAlias: selectedStore?.friendly_name,
            knowledgeBase: {
              method: 'quesandAnswer',
              qna: questions.map((q, index) => ({
                id:
                  (selectedStore?.storeknowledgeBase?.qna?.length || 0) +
                  index +
                  1,
                ques: q.ques || q.question,
                ans: q.ans || q.answer,
              })),
            },
          },
        ],
      };

      createStoreKnowledge(formattedData, {
        onSuccess: () => {
          setIsQuestionnaireDrawerOpen(false);
          showAlert('Questions added successfully', 'success');
        },
        onError: (error: any) => {
          showAlert(
            error.response?.data?.message || 'Error adding questions',
            'error'
          );
        },
      });
    } catch (error) {
      console.error('Error saving questionnaire:', error);
      showAlert('Error adding questions', 'error');
    }
  };

  return (
    <>
      {selectedMethod === 'file-upload' ? (
        <KnowledgeBAseFiles
          isGeneralSupport={false}
          setIsModalOpen={setIsModalOpen}
          selectedStoreId={selectedStore?.id}
          isStoreLoading={storesListLoading}
        />
      ) : (
        <Questionnaire
          isGeneralSupport={false}
          height="calc(100vh - 180px)"
          selectedStore={selectedStore}
          isNewQuestion={isNewQuestion}
          setIsNewQuestion={setIsNewQuestion}
          isStoreLoading={storesListLoading}
        />
      )}

      <KnowledgeBaseFileUploadModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedStore={selectedStore}
      />

      <QuestionnaireDrawer
        open={isQuestionnaireDrawerOpen}
        onClose={() => setIsQuestionnaireDrawerOpen(false)}
        selectedStore={{
          id: selectedStore?.id,
          friendly_name: selectedStore?.friendly_name,
          existingQuestionsCount:
            selectedStore?.storeknowledgeBase?.qna?.length || 0,
        }}
        onSave={handleSaveQuestions}
        isPending={isPending}
      />
    </>
  );
};

export default KnowledgeBase;
